export const extractVimeoId = (mediaVideoLink: string): string => {
    const regEx = /vimeo\.com\/(?:video\/)?(\d+)/;
    const match = mediaVideoLink.match(regEx);
    return match ? match[1] : '';
};

export const extractVimeoHParam = (videoLink: string): string => {
    const [baseUrl] = videoLink.split('?');
    return baseUrl.slice(-10);
};